<template>
  <transition name="alert-fade">
    <div id="toast"
         v-show="visible"
         class="dialog-tips dialog-center">
        <svg class="ico w1x h1x fPrimary mr05x"><use xlink:href="#status-info"></use></svg> 
        {{message}}
    </div>
  </transition>
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      message: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.alert-fade-enter-active,
.alert-fade-leave-active {
  transition: opacity 0.3s;
}
.alert-fade-enter,
.alert-fade-leave-to {
  opacity: 0;
}
.dialog-tips {
    position: fixed;
    z-index: 100;
    min-width: 10em;
    padding: 1em;
    border-radius: 0.5em;
    white-space: nowrap;
    background-color: #fff;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    text-align: center;
    font-size: 14px;
    display: flex;
    vertical-align: middle;
}
.dialog-center {
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/plugins/toast/toast.vue